let topInset = 0;

const applyAppHeight = (): void => {
    const doc = document.documentElement;
    doc.style.setProperty('--100vh', `${window.innerHeight - topInset}px`);
    doc.style.setProperty('--app-top-inset', `${topInset}px`);
};

export const setAppTopInset = (pixels: number): void => {
    topInset = pixels;
    applyAppHeight();
};

export const init = (): void => {
    window.addEventListener('resize', applyAppHeight);
    applyAppHeight();
};
